shadow$provide[117] = function(require,module,exports) {
var require$three = require("three");
var require$_DOT__DOT__SLASH_bootstrap = require("../bootstrap");
require$_DOT__DOT__SLASH_bootstrap.Bootstrap.registerPlugin("controls", {listen:["update", "resize", "camera", "this.change"], defaults:{klass:null, parameters:{},}, install:function(three) {
  if (!this.options.klass) {
    throw "Must provide class for `controls.klass`";
  }
  three.controls = null;
  this._camera = three.camera || new require$three.PerspectiveCamera();
  this.change(null, three);
}, uninstall:function(three) {
  delete three.controls;
}, change:function(event, three) {
  if (this.options.klass) {
    if (!event || event.changes.klass) {
      three.controls = new this.options.klass(this._camera, three.renderer.domElement);
    }
    Object.assign(three.controls, this.options.parameters);
  } else {
    three.controls = null;
  }
}, update:function(event, three) {
  const delta = three.Time && three.Time.delta || 1 / 60;
  const vr = three.VR && three.VR.state;
  if (three.controls.vr) {
    three.controls.vr(vr);
  }
  three.controls.update(delta);
}, camera:function(event, three) {
  three.controls.object = this._camera = event.camera;
}, resize:function(event, three) {
  three.controls.handleResize && three.controls.handleResize();
},});

};